import { render, staticRenderFns } from "./HSCode.vue?vue&type=template&id=db9465da"
import script from "./HSCode.vue?vue&type=script&lang=js"
export * from "./HSCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports